<button mat-list-item (click)="clicked.emit()" [disabled]="disabled" [class.disabled-button]="disabled">
    <div matListItemTitle>{{ title }}</div>
    <div matListItemLine>{{value == '' ? 'No value' : value}}</div>
    <div matListItemMeta style="font-size: 1em;">
        <button mat-icon-button [disabled]="disabled">
            <app-icon [icon]="icon"></app-icon>
        </button>
    </div>
</button>